import { useTranslation } from 'react-i18next'
import { Route, Routes } from 'react-router-dom'

import { Dashboard } from '../components/Dashboard'
import { Tenants } from '../components/Tenants'
import { TenantProfile } from '../components/Tenants/TenantProfile'
import pathnames from '../config/pathnames'

const AppRouter = () => {
  const { t } = useTranslation()

  return (
    <Routes>
      <Route path={pathnames.dashboard} element={<Dashboard />} />
      <Route path={pathnames.tenants} element={<Tenants />} />
      <Route path={pathnames.tenantProfile} element={<TenantProfile />} />

      <Route
        path={pathnames.tenantProfileLicenses}
        element={<TenantProfile />}
      />
      <Route
        path={pathnames.tenantProfileSettings}
        element={<TenantProfile />}
      />

      <Route
        path={pathnames.notFound}
        element={<div>{t('General.NotFound')}</div>}
      />
    </Routes>
  )
}

export default AppRouter
